import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
    selectedArticle: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedArticle(state, payload) {
      state.selectedArticle = payload;
    },
  },
  actions: {
    async loadAllBySolutionID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/articles/bySolutionsID", {
        params: { id: id }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadArticleByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/articles/byID", {
        params: { id: id }
      });
      commit("setSelectedArticle", list.data[0]);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("solutions/articles", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAllBySolutionID", payload.solutions_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`solutions/articles`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAllBySolutionID", payload.solutions_id);
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedArticle(state) {
      return state.selectedArticle;
    }
  }
}
